export class Property {
  constructor(
    public location: number,
    public price: number,
    public rent: number,
    public owner: string
  ) {}
}



// WEBPACK FOOTER //
// /Users/philipeskins/Desktop/Epicodus/monopoly/src/app/properties.model.ts